<div *ngIf="tab=='news'" class="news-wrapper">
  <app-company-news [cin]="cin" [all_data]="all_data"></app-company-news>
</div>
<div *ngIf="tab=='timeline'" class="news-wrapper">
  <app-company-timeline [cin]="cin" [all_data]="all_data"></app-company-timeline>
</div>
<div #centerColumn *ngIf="tab!=='news' && tab !== 'timeline'">
  <div *ngIf="all_data">
    <div id="comp_overview" #comp_overview class="company-details">
      <app-company-overview [cin]="cin" [all_data]="all_data" *ngIf="overview"></app-company-overview>
    </div>
    <div id="comp_funding" #comp_funding class="company-funding">
      <app-company-funding [cin]="cin" [all_data]="all_data" *ngIf="funding"></app-company-funding>
    </div>
    <div id="comp_financials" #comp_financials class="company-financial">
      <app-company-financial [cin]="cin" [all_data]="all_data" *ngIf="financials"></app-company-financial>
    </div>
    <div id="comp_people" #comp_people class="company-people">
      <app-company-people [all_data]="all_data" *ngIf="people"></app-company-people>
    </div>
    <div id="comp_roc" #comp_roc class="company-roc">
      <app-company-roc [cin]="cin" [all_data]="all_data" *ngIf="roc"></app-company-roc>
    </div>
  </div>
</div>

<app-subscribe-form-component *ngIf="tab!=='news' && tab !== 'timeline'"></app-subscribe-form-component>
